<template>
  <div id="index">
    <!-- <div class="img-wrap" :style="{backgroundImage:'url('+bg_t+')'}"></div> -->
    <div class="ani_img">
      <img src="https://h5stc.oss-cn-shanghai.aliyuncs.com/register/51/img/jiao.png" alt class />
    </div>
    <div class="animate-num">{{animate_num}}</div>
    <img :src="topImg" width="100%" height="auto" class="img-wrap" />
    <div class="animate-text animate-text-1">1个月</div>
    <div class="animate-text animate-text-2">6个月</div>
    <div class="animate-text animate-text-3">9个月</div>
    <div class="animate-text animate-text-4">12个月</div>
    <div class="animate-text animate-text-5">48个月</div>
    <div class="in-wrap" v-if="!is_down_page">
      <router-view class="child-view"></router-view>
    </div>
    <div class="in-wrap" style="padding-top:7.34rem" v-if="is_down_page">
      <router-view class="child-view"></router-view>
    </div>
    <!-- <img class="bottom-img" src="https://h5stc.oss-cn-shanghai.aliyuncs.com/register/5/img/bottom.png" alt="" width="100%" height="auto"> -->
    <div class="bottom-text">
      <div v-for="item in bottom_text">{{item}}</div>
    </div>

    <!-- <div class="app-img">上海酷犇科技有限公司</div> -->

    <!-- </div> -->
  </div>
</template>

<script>
// import bg_t from '../assets/image/bg.png'

export default {
  name: "index",
  data() {
    return {
      bottom_text: window.bottom_text,
      animate_num: 0
    };
  },
  methods: {
    m_interval(i) {
      // let num_arr = [
      //   2000,
      //   2005,
      //   2102,
      //   2304,
      //   2688,
      //   3301,
      //   4231,
      //   5233,
      //   6232,
      //   7879,
      //   8314,
      //   9231,
      //   12310,
      //   13932,
      //   14230,
      //   15410,
      //   16899,
      //   17521,
      //   19238,
      //   20000
      // ];
      let num = 0;
      clearInterval(interval);

      let interval = setInterval(() => {
        num++;
        this.animate_num += parseInt(Math.random() * 4000);
        if (i == 4) {
          this.animate_num = 200000;
        }
        if (num == 20) {
          clearInterval(interval);
        }
      }, 45);
    }
  },
  mounted() {
    for (let i = 0; i < 50; i += 10) {
      let num = i / 10;
      let text = document.getElementsByClassName("animate-text");

      setTimeout(() => {
        for (let d = 0; d < text.length; d++) {
          text[d].style.opacity = 0.4;
        }
        text[num].style.opacity = 1;

        this.m_interval(i / 10);
      }, num * 1000);
    }
  },
  created() {
    // console.log(this.is_down_page)
    // let reg = new RegExp("(^|&)aldtype=([^&]*)(&|$)");
    // this.url_n = window.location.search.substr(1).match(reg);
    // if(this.url_n==null){
    //    this.$router.push({
    //     path: '/Download2/',
    //   })
    // }else{
    //   this.$router.push({
    //     path: '/Index/',
    //   })
    // }
  }
};
</script>

<style>
html,
body {
  height: 100%;
}
body {
  margin: 0 auto;
  /* color: #fff; */

  font-family: microsoft yahei;
  font: 0.83rem/1.5 黑体, sans-serif;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
p,
dl,
dt,
dd,
table,
td,
th,
input,
img,
form,
div,
span,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
select,
input {
  margin: 0;
  padding: 0;
  font-weight: normal;
}
img,
iframe {
  border: none;
}
ul,
li,
ol {
  list-style: none;
}
img {
  vertical-align: middle;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
input {
  outline: none;
  border: 0px;
}
em,
b,
i,
strong,
cite,
sub,
sup,
font {
  font-weight: normal;
  font-style: normal;
  font-size: 100%;
}
a {
  text-decoration: none;
  outline: none;
  color: #9c9c9c;
  display: none;
}
button {
  border: 0 none;
  outline: none;
}
#app {
  text-align: center;
  height: 100%;
}
.app-img {
  padding-top: 2rem;
  height: 4rem;
  color: #fff;
}
.in-wrap {
  position: relative;
  width: 9.4rem;
  margin: 0 auto;
  padding: 1rem 0 1rem 0;
  padding-top: 9.8rem;
}
.img-wrap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.img-wrap-2 {
  background-size: 100% 100%;
  padding-top: 2rem;
}
.in-back {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.7;
  border-radius: 1.1rem;
  z-index: 0;
}
#index {
  position: relative;
  height: 100%;
  /* background: #3da6e2; */
}
.img-pep {
  height: 3rem;
  width: 3rem;
  background-size: contain;
  position: absolute;
  top: -1rem;
  right: 0;
  z-index: 100;
  background-repeat: no-repeat;

}
.bottom-text {
  position: absolute;
  top: 23rem;
  left: 0;
  width: 100%;
  font-size: 0.4rem;
  color: #fff;
}
.ani_img {
  position: absolute;
  top: 2.66rem;
  left: 50%;
  z-index: 2;
  text-align: center;
  /* background: red;
  opacity: 0.6; */
  height: 6.48rem;
  width: 6.48rem;
  margin-left: -3.24rem;
  border-radius: 100%;
  transform: rotate(214.5deg);
  animation: animate 4.5s 1;
}
.ani_img img {
  position: absolute;
  left: -0.2rem;
  bottom: 2.18rem;
  width: 0.5rem;
  height: auto;
}
@keyframes animate {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(53deg);
  }
  50% {
    transform: rotate(106deg);
  }
  75% {
    transform: rotate(159deg);
  }
  100% {
    transform: rotate(214.5deg);
  }
}
.animate-num {
  position: absolute;
  left: 0rem;
  top: 4rem;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 1.5rem;
}
.animate-text {
  position: absolute;
  color: #fff;
  font-size: 0.35rem;
  opacity: 0.4;
}
.animate-text-1 {
  top: 6.45rem;
  left: 0.5rem;
}
.animate-text-2 {
  top: 3.1rem;
  left: 1.2rem;
}
.animate-text-3 {
  top: 1.2rem;
  left: 5rem;
}
.animate-text-4 {
  top: 2.88rem;
  right: 1rem;
}
.animate-text-5 {
  top: 6.45rem;
  right: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue